<template lang="html">
    <div class="thank-page flex">
        <h2 class="title title-36">
            {{ $t('formulario.thank_you.title') }}
        </h2>
        <div class="text" v-html="$t('formulario.thank_you.text')"></div>
        <router-link to="/" class="btn btn-dark -enviar -pink-full">{{ $t('formulario.thank_you.btn_text') }}</router-link>
    </div>
</template>
  
<script lang="js">

export default {
    name: 'thank-you-send-form',
    props: [],
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>
  
<style scoped>
.thank-page {
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    min-height: 40vh;
    margin-top: 20vh;
}

#solicita-catalogo .thank-page {
    min-height: 30vh;
    margin-top: 0vh;
}

.trabaja-nosotros .thank-page {
    margin-top: 0vh;
    min-height: 30vh;
}

.thank-page .text {
    margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/parts/thank-you-send-form.vue